import { create } from 'zustand';
import { ModalType } from '../types';

type MobileView = 'list' | 'chat' | 'customer';

interface UIState {
  sidebarOpen: boolean;
  customerPanelOpen: boolean;
  copilotPanelOpen: boolean;
  // Pending text to load into the customer composer ("Use to customer" on a
  // copilot reply). MessageInput consumes and clears it.
  composerDraft: string | null;
  activeModal: ModalType;
  modalData: any;
  mobileView: MobileView;
  soundEnabled: boolean;

  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleCustomerPanel: () => void;
  setCustomerPanelOpen: (open: boolean) => void;
  toggleCopilotPanel: () => void;
  setCopilotPanelOpen: (open: boolean) => void;
  setComposerDraft: (text: string | null) => void;
  openModal: (type: Exclude<ModalType, null>, data?: any) => void;
  closeModal: () => void;
  setMobileView: (view: MobileView) => void;
  toggleSound: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  customerPanelOpen: true,
  copilotPanelOpen: false,
  composerDraft: null,
  activeModal: null,
  modalData: null,
  mobileView: 'list' as MobileView,
  soundEnabled: localStorage.getItem('soundEnabled') !== 'false',

  toggleSidebar: () => {
    set((state) => ({ sidebarOpen: !state.sidebarOpen }));
  },

  setSidebarOpen: (open) => {
    set({ sidebarOpen: open });
  },

  toggleCustomerPanel: () => {
    set((state) => ({ customerPanelOpen: !state.customerPanelOpen }));
  },

  setCustomerPanelOpen: (open) => {
    set({ customerPanelOpen: open });
  },

  toggleCopilotPanel: () => {
    set((state) => ({ copilotPanelOpen: !state.copilotPanelOpen }));
  },

  setCopilotPanelOpen: (open) => {
    set({ copilotPanelOpen: open });
  },

  setComposerDraft: (text) => {
    set({ composerDraft: text });
  },

  openModal: (type, data) => {
    set({ activeModal: type, modalData: data });
  },

  closeModal: () => {
    set({ activeModal: null, modalData: null });
  },

  setMobileView: (view) => {
    set({ mobileView: view });
  },

  toggleSound: () => {
    set((state) => {
      const next = !state.soundEnabled;
      localStorage.setItem('soundEnabled', String(next));
      return { soundEnabled: next };
    });
  },
}));
